import React from 'react';
import { Linkedin, Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    Services: [
      { label: 'Loan Origination', href: '/services#loan-origination' },
      { label: 'Lease Administration', href: '/services#lease-administration' },
      { label: 'Consulting', href: '/services#consulting' },
      { label: 'ARGUS Modeling', href: '/services/argus-modeling' },
      { label: 'GCC - Hire in India', href: '/gcc-hire-india' }
    ],
    Company: [
      { label: 'About Us', href: '/about' },
      { label: 'Project Showcase', href: '/case-studies' },
      { label: 'Careers', href: '#careers' },
      { label: 'Contact Us', href: '#contact' }
    ],
    Resources: [
      { label: 'Blog', href: '#blog' },
      { label: 'Insights', href: '#insights' },
      { label: 'FAQ', href: '/services#faq' }
    ]
  };

  return (
    <footer className="bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-6">
              <img 
                src="/integrand-logo.png" 
                alt="Integrand Analytics" 
                className="h-10 w-auto brightness-0 invert"
              />
            </Link>
            <p className="text-gray-400 mb-6 max-w-sm text-sm leading-relaxed">
              An independent capital market advisory and financial analytics firm providing knowledge process outsourcing (KPO) services to the commercial real estate industry.
            </p>
            
            {/* Contact Info */}
            <div className="space-y-3">
              <a href="tel:+16473896552" className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors text-sm">
                <Phone className="w-4 h-4 text-[#005B63]" />
                +1 647 389 6552
              </a>
              <a href="mailto:contact@integrand.in" className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors text-sm">
                <Mail className="w-4 h-4 text-[#005B63]" />
                contact@integrand.in
              </a>
              <div className="flex items-start gap-3 text-gray-400 text-sm">
                <MapPin className="w-4 h-4 text-[#005B63] mt-0.5" />
                <span>USA | Canada | India</span>
              </div>
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className="text-white font-semibold mb-4">{category}</h3>
              <ul className="space-y-3">
                {links.map((link, index) => (
                  <li key={index}>
                    <Link
                      to={link.href}
                      className="text-gray-400 hover:text-[#00A3B1] transition-colors text-sm"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm">
              © {currentYear} Integrand Analytics. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#privacy" className="text-gray-500 hover:text-white text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="#terms" className="text-gray-500 hover:text-white text-sm transition-colors">
                Terms of Service
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 rounded-lg bg-gray-800 flex items-center justify-center text-gray-400 hover:text-white hover:bg-[#005B63] transition-all"
              >
                <Linkedin size={16} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
